import { render, staticRenderFns } from "./EducationDetail.vue?vue&type=template&id=a0b65328&scoped=true&"
import script from "./EducationDetail.vue?vue&type=script&lang=js&"
export * from "./EducationDetail.vue?vue&type=script&lang=js&"
import style0 from "./EducationDetail.vue?vue&type=style&index=0&id=a0b65328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b65328",
  null
  
)

export default component.exports